import { Space } from 'antd'
import customDataTableStyle from 'assets/styles/customDataTableStyle'
import reportHelper from 'features/Report/reportHelper'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import SelectOptions from 'general/constants/SelectOptions'
import Utils, {
  customCutNumber,
  findMaxNo,
  findObjectInArray,
  formatNumberWithCommas,
  getTaxMoneyInvoiceProductMulti,
  getYearsFromDates,
  isDifferenceLessThan1,
  taxRateInXml,
} from 'general/utils/Utils'
import useGetSerials from 'hooks/Queries/useGetSerials'
import useAppDnD from 'hooks/useAppDnD'
import useFilter from 'hooks/useFilter'
import { useAppSelector } from 'hooks/useRedux'
import useSearchDebounce from 'hooks/useSearchDebounce'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useExportMutation, useGetDetailInvoiceReport } from './queries'
import _ from 'lodash'
import $ from 'jquery'
import { goodsQueries } from 'features/Category/screens/GoodsScreen/queries'
import { useQuery } from '@tanstack/react-query'
import { Row } from 'antd/lib'
import AppData from 'general/constants/AppData'
import wsHelperInstance from 'general/helpers/WebSocketHelper'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import {
  ButtonSave,
  DivColFooter,
  DivFooter,
  DivRowFooter,
  ModalWrapperTool,
} from 'features/TaxDeduction/styled'

function DetailInvoiceReportScreen(props) {
  // MARK --- Parmas: ---
  const { t } = useTranslation()
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')

  const sysConfig = useAppSelector((s) => s.systemConfig.formatNumber)
  const [filters, setFilters] = useFilter(
    'detailInvoiceList',
    'gFiltersDetailInvoices',
  )
  const [goodsFilterParams] = useState({
    q: '',
    page: 0,
    limit: 50,
    status: 'ACTIVE',
  })

  const [inforSettingTool, setInforSettingTool] = useState({ show: false })

  const { data: goodsOptions } = useQuery({
    ...goodsQueries.listOfGoods(goodsFilterParams),
    select: (res) => {
      return _.concat(
        [{ value: null, label: 'Tất cả hàng hóa' }],
        res.goods,
      ).map((v) => ({
        value: v.name ?? v.value,
        label: v.label ?? v.name,
      }))
    },
  })
  const [dateSerial, setDateSerial] = useState([])
  const { data: serials } = useGetSerials('ALL', undefined, dateSerial)

  const parseJSONSafely = (value) => {
    if (typeof value !== 'string') return value // Nếu không phải string, trả về chính nó

    try {
      const parsed = JSON.parse(value)
      return parsed
    } catch (error) {
      return value // Nếu lỗi, trả về giá trị ban đầu
    }
  }

  const {
    data: detailInvoices,
    isFetching: isGettingDetailInvoice,
    refetch,
  } = useGetDetailInvoiceReport(debouncedSearch, filters)

  console.log('detailInvoices', detailInvoices)

  const { formatNumber } = useAppSelector((state) => state?.systemConfig)

  const fullColumns = useMemo(
    () => [
      {
        name: 'Số hoá đơn',
        id: 'invoiceOfInvoiceProduct.no',
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const invoiceNo = xml
          //   ? $(xml).find('SHDon').text()
          //   : row?.invoiceOfInvoiceProduct?.no
          const invoiceNo = row?.invoiceOfInvoiceProduct?.no
          return (
            <div
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-bold m-0 text-maxline-3 d-flex align-items-center"
            >
              {invoiceNo ? Utils.padString(invoiceNo, 8, '0') : ''}
            </div>
          )
        },
      },
      {
        center: true,
        id: 'invoiceOfInvoiceProduct.type',
        name: 'Loại hóa đơn',
        minWidth: '140px',
        cell: (row) => {
          return (
            <p
              data-tag="allowRowEvents"
              className={`m-0 badge badge-light-${reportHelper.getInvoiceTypeColor(
                row?.invoiceOfInvoiceProduct?.type,
              )}`}
              style={{ whiteSpace: 'nowrap' }}
            >
              {reportHelper.getInvoiceTypes(row?.invoiceOfInvoiceProduct?.type)}
            </p>
          )
        },
      },
      {
        center: true,
        id: 'invoiceOfInvoiceProduct.serial',
        name: t('Symbol'),
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          const invoiceSerial = row?.invoiceOfInvoiceProduct?.serial
          return (
            <p className="font-weight-normal m-0 text-maxline-2">
              {invoiceSerial}
            </p>
          )
        },
      },
      {
        center: true,
        id: 'invoiceOfInvoiceProduct.date',
        name: t('ContractDay'),
        width: '120px',
        cell: (row) => {
          console.log(
            'row?.invoiceOfInvoiceProduct?.date',
            row?.invoiceOfInvoiceProduct?.date,
          )
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {Utils.formatDateTime(
                row?.invoiceOfInvoiceProduct?.date,
                'DD/MM/YYYY',
              )}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerCompanyName',
        name: t('CustomerName'),
        center: true,
        minWidth: '250px',
        cell: (row) => {
          let invoiceType = row?.invoiceOfInvoiceProduct?.serial?.charAt(4)
          let classify = row?.invoiceOfInvoiceProduct?.classify
          let customerName
          if (classify === 'PXK') {
            customerName =
              invoiceType === 'N'
                ? (row?.invoiceOfInvoiceProduct?.consigneeUnitName ?? '')
                : (row?.invoiceOfInvoiceProduct?.invoiceNote ?? '')
          } else {
            customerName = row?.invoiceOfInvoiceProduct?.customerCompanyName
              ? row?.invoiceOfInvoiceProduct?.customerCompanyName
              : process.env.REACT_APP_BASE_URL === 'petro.vietinvoice.vn'
                ? row?.invoiceOfInvoiceProduct?.customerName
                : ''
          }
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const customerName = xml
          //   ? $(xml).find('NMua > Ten').text()
          //   : row?.invoiceOfInvoiceProduct?.customerCompanyName
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {customerName}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerFullAddress',
        name: t('Address'),
        center: true,
        minWidth: '250px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const customerAddress = xml
          //   ? $(xml).find('NMua > DChi').text()
          //   : row?.invoiceOfInvoiceProduct?.customerFullAddress
          let invoiceType = row?.invoiceOfInvoiceProduct?.serial?.charAt(4)
          let classify = row?.invoiceOfInvoiceProduct?.classify
          let customerAddress
          if (classify === 'PXK') {
            customerAddress =
              invoiceType === 'N'
                ? (row?.invoiceOfInvoiceProduct?.addressWarehouse ?? '')
                : (row?.invoiceOfInvoiceProduct?.toWarehouseName ?? '')
          } else {
            customerAddress =
              row?.invoiceOfInvoiceProduct?.customerFullAddress ?? ''
          }
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {customerAddress}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerTaxCode',
        name: t('TaxCode'),
        center: true,
        width: '140px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const customerTaxCode = xml
          //   ? $(xml).find('NMua > MST').text()
          //   : row?.invoiceOfInvoiceProduct?.customerTaxCode
          let invoiceType = row?.serial?.charAt(4)
          let classify = row?.classify
          let customerTaxCode
          if (classify === 'PXK') {
            customerTaxCode =
              invoiceType === 'N'
                ? (row?.invoiceOfInvoiceProduct?.consigneeUnitTaxcode.trim() ??
                  '')
                : (row?.invoiceOfInvoiceProduct?.buyerTaxCode?.trim() ?? '')
          } else {
            customerTaxCode = row?.invoiceOfInvoiceProduct?.customerTaxCode
              ? row?.invoiceOfInvoiceProduct?.customerTaxCode.trim()
              : ''
          }
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {customerTaxCode}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerName',
        name: t('Buyer'),
        center: true,
        minWidth: '250px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const customerName = xml
          //   ? $(xml).find('NMua > HVTNMHang').text()
          //   : row?.invoiceOfInvoiceProduct?.customerName
          let invoiceType = row?.serial?.charAt(4)
          let classify = row?.classify
          let customerName
          if (classify === 'PXK') {
            customerName =
              invoiceType === 'N'
                ? (row?.invoiceOfInvoiceProduct?.importerName ?? '')
                : (row?.invoiceOfInvoiceProduct?.stockInFullName ?? '')
          } else {
            customerName = row?.invoiceOfInvoiceProduct?.customerName ?? ''
          }
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {customerName}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.paymentMethod',
        name: t('PaymentMethod'),
        center: true,
        minWidth: '150px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const paymentMethod = xml
          //   ? $(xml).find('HTTToan').text()
          //   : reportHelper.getPaymentMethod(
          //       row?.invoiceOfInvoiceProduct?.paymentMethod,
          //     )
          let paymentMethod = row?.invoiceOfInvoiceProduct?.paymentMethod
            ? AppData.paymentMethod[row?.invoiceOfInvoiceProduct?.paymentMethod]
            : ''
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {paymentMethod}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.currency',
        name: t('MoneyType'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const currency = xml
          //   ? $(xml).find('DVTTe').text()
          //   : row?.invoiceOfInvoiceProduct?.currency
          let currency =
            row?.invoiceOfInvoiceProduct?.currency === 'VNĐ'
              ? 'VND'
              : row?.invoiceOfInvoiceProduct?.currency
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {currency}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.exchangeRate',
        name: t('ExchangeRate'),
        center: true,
        cell: (row) => {
          console.log(
            'row?.numberFormat',
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const exchangeRate = xml
          //   ? ($(xml).find('TGia')?.text() ??
          //     row?.invoiceOfInvoiceProduct?.exchangeRate)
          //   : row?.invoiceOfInvoiceProduct?.exchangeRate
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {Utils.valueFormatted(
                exchangeRate,
                parseJSONSafely(row?.invoiceOfInvoiceProduct?.numberFormat),
                sysConfig ?? detailInvoices?.systemformatNumber,
                'exchangeRate',
              )}
            </p>
          )
        },
      },
      {
        id: 'name',
        name: t('CommodityName'),
        center: true,
        minWidth: '300px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const productName = xmlProduct
          //   ? $(xmlProduct).find('THHDVu').text()
          //   : row?.name
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {row?.name}
            </p>
          )
        },
      },
      {
        name: t('Unit'),
        center: true,
        id: 'unit',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const unit = xmlProduct
          //   ? $(xmlProduct).find('DVTinh').text()
          //   : row?.unit
          let unit = row?.unit
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {unit}
            </p>
          )
        },
      },
      {
        id: 'quantity',
        name: t('Quantity'),
        center: true,
        cell: (row) => {
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          if (!numberFormat) numberFormat = sysConfig
          let serialType = row?.invoiceOfInvoiceProduct?.serial?.charAt(0)
          let quantity
          if (serialType == '1') {
            // quantity = customCutNumber(row?.quantity, numberFormat?.quantity)
            quantity = _.isNumber(row?.quantity)
              ? parseFloat(row?.quantity).toFixed(numberFormat?.quantity)
              : ''
          } else if (serialType == '2') {
            // quantity = customCutNumber(row?.quantity, numberFormat?.quantity)
            quantity = _.isNumber(row?.quantity)
              ? parseFloat(row?.quantity).toFixed(numberFormat?.quantity)
              : ''
          } else if (serialType == '6') {
            let invoiceType = row?.invoiceOfInvoiceProduct?.serial?.charAt(4)
            if (invoiceType === 'B' && _.isNumber(row?.quantity)) {
              // quantity = customCutNumber(row?.quantity, numberFormat?.quantity)
              quantity = parseFloat(row?.quantity).toFixed(
                numberFormat?.quantity,
              )
            } else if (invoiceType === 'N' && _.isNumber(row?.actualExport)) {
              // quantity = customCutNumber(
              //   row?.actualExport,
              //   numberFormat?.quantity,
              // )
              quantity = parseFloat(row?.actualExport).toFixed(
                numberFormat?.actualExport,
              )
            } else {
              quantity = ''
            }
          }
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const quantity = xmlProduct
          //   ? $(xmlProduct).find('SLuong').text()
          //   : row?.quantity

          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                quantity,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'quantity',
              )} */}
              {formatNumberWithCommas(
                quantity,
                // (row?.invoiceOfInvoiceProduct?.numberFormat ?? formatNumber)?.quantity
                numberFormat?.quantity,
              )}
              {/* {quantity} */}
            </p>
          )
        },
      },
      {
        id: 'unitPrice',
        name: t('UnitPrice'),
        minWidth: '120px',
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const unitPrice = xmlProduct
          //   ? $(xmlProduct).find('DGia').text()
          //   : row?.unitPrice
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          if (!numberFormat) numberFormat = detailInvoices?.systemformatNumber
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let unitPrice = _.isNumber(row?.unitPrice)
            ? parseFloat(row?.unitPrice).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.unitPrice
                    : numberFormat?.currencyUnitPrice
                  : checkCheck
                    ? sysConfig?.unitPrice
                    : sysConfig?.currencyUnitPrice,
              )
            : 0
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {/* {
                Utils.valueFormatted(
                  unitPrice,
                  row?.numberFormat,
                  sysConfig,
                  'unitPrice',
                )
              )} */}
              {/* {formatNumberWithCommas(
                unitPrice,
                numberFormat
                  ? checkCheck
                    ? numberFormat?.unitPrice
                    : numberFormat?.exchangeTotalCost
                  : checkCheck
                    ? sysConfig?.unitPrice
                    : sysConfig?.exchangeTotalCost,
              )} */}
              {formatNumberWithCommas(
                unitPrice,
                numberFormat?.[checkCheck ? 'unitPrice' : 'currencyUnitPrice'],
              )}
            </p>
          )
        },
      },
      {
        id: 'totalUnitPrice',
        name: t('IntoMoney'),
        minWidth: '110px',
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const totalUnitPrice = xmlProduct
          //   ? $(xmlProduct).find('ThTien').text()
          //   : row?.totalUnitPrice
          let totalUnitPrice
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          // if (row?.invoiceOfInvoiceProduct?.multipleTaxRate) {
          // let invoiceProduct =
          //   detailInvoices?.formattedData?.[
          //     row?.invoiceOfInvoiceProduct?.invoiceId
          //   ]
          // let taxArray = calculateTaxArray(invoiceProduct)
          // if (row?.invoiceOfInvoiceProduct?.invoiceId == 5529449) {
          //   console.log('taxArray', taxArray)
          //   console.log(
          //     'detailInvoices?.formattedData',
          //     detailInvoices?.formattedData,
          //   )
          //   console.log('invoiceProduct', invoiceProduct)
          // }

          // totalUnitPrice = parseFloat(
          //   findObjectInArray(
          //     taxArray,
          //     'invoiceProductId',
          //     row?.invoiceProductId,
          //   )?.total ?? 0,
          // ).toFixed(numberFormat?.totalCost)
          // } else {
          //   totalUnitPrice = parseFloat(
          //     row?.invoiceOfInvoiceProduct?.total ?? 0,
          //   ).toFixed(numberFormat?.totalCost)
          // }
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          totalUnitPrice = parseFloat(row?.totalUnitPrice ?? 0).toFixed(
            numberFormat
              ? checkCheck
                ? numberFormat?.currencyExchange
                : numberFormat?.foreignCurrency
              : checkCheck
                ? sysConfig?.currencyExchange
                : sysConfig?.foreignCurrency,
          )
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                totalUnitPrice,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'totalAmount',
              )} */}
              {/* {formatNumberWithCommas(
                totalUnitPrice,
                numberFormat
                  ? checkCheck
                    ? numberFormat?.unitPrice
                    : numberFormat?.exchangeTotalCost
                  : checkCheck
                    ? sysConfig?.unitPrice
                    : sysConfig?.exchangeTotalCost,
              )} */}
              {formatNumberWithCommas(
                totalUnitPrice,
                !['VNĐ', 'VND'].includes(row?.invoiceOfInvoiceProduct?.currency)
                  ? // ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     numberFormat)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ]
                    // : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     numberFormat)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ],
                    numberFormat?.foreignCurrency
                  : numberFormat?.currencyExchange,
              )}
            </p>
          )
        },
      },
      {
        id: 'totalUnitPriceConvert',
        name: t('IntoMoneyConvert'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // let exchangeRate
          // if (xml) {
          //   const TGiaText = $(xml).find('TGia')?.text()
          //   exchangeRate = TGiaText
          //     ? TGiaText
          //     : row?.invoiceOfInvoiceProduct?.exchangeRate
          // } else {
          //   exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          // }
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const totalUnitPriceConvert = xmlProduct
          //   ? Number($(xmlProduct).find('ThTien').text()) * Number(exchangeRate)
          //   : row?.totalUnitPrice * row?.invoiceOfInvoiceProduct?.exchangeRate
          let totalUnitPrice
          let totalUnitPriceConvert
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          if (!numberFormat) numberFormat = sysConfig
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          totalUnitPrice = parseFloat(row?.totalUnitPrice ?? 0).toFixed(
            numberFormat
              ? checkCheck
                ? numberFormat?.currencyExchange
                : numberFormat?.foreignCurrency
              : checkCheck
                ? sysConfig?.currencyExchange
                : sysConfig?.foreignCurrency,
          )
          totalUnitPriceConvert = totalUnitPrice
            ? Number(totalUnitPrice) * Number(exchangeRate)
            : row?.totalUnitPrice * row?.invoiceOfInvoiceProduct?.exchangeRate
          return (
            <p
              data-tag="allowRowEvents"
              className="text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                totalUnitPriceConvert,
                row?.numberFormat,
                sysConfig,
                'totalAmount',
              )} */}
              {/* {formatNumberWithCommas(
                totalUnitPriceConvert,
                numberFormat
                  ? checkCheck
                    ? numberFormat?.totalCost
                    : numberFormat?.exchangeTotalCost
                  : checkCheck
                    ? sysConfig?.totalCost
                    : sysConfig?.exchangeTotalCost,
              )} */}

              {formatNumberWithCommas(
                totalUnitPriceConvert,
                !['VNĐ', 'VND'].includes(row?.invoiceOfInvoiceProduct?.currency)
                  ? // (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     formatNumber)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ]
                    // : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     formatNumber)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ],
                    numberFormat?.foreignCurrency
                  : numberFormat?.currencyExchange,
              )}
            </p>
          )
        },
      },
      {
        id: 'discount',
        name: t('DiscountRate') + '(%)',
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const discount = xml
          //   ? $(xmlProduct).find('TLCKhau').text()
          //   : row?.discount
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          let discount = _.isNumber(row?.discount)
            ? parseFloat(row?.discount).toFixed(numberFormat?.ratio)
            : ''
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                discount,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'ratio',
              )} */}
              {discount == ''
                ? ''
                : // formatNumberWithCommas(
                  //     discount,
                  //     numberFormat
                  //       ? numberFormat?.totalAmount
                  //       : sysConfig?.totalAmount,
                  //   )}
                  formatNumberWithCommas(
                    discount,
                    !['VNĐ', 'VND'].includes(
                      row?.invoiceOfInvoiceProduct?.currency,
                    ),
                    numberFormat?.ratio,
                    //? // ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     formatNumber)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ]
                    // : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                    //     formatNumber)?.[
                    //     checkCheck ? 'currencyExchange' : 'foreignCurrency'
                    //   ],
                    //   numberFormat?.foreignCurrency
                    // : numberFormat?.currencyExchange,
                  )}
            </p>
          )
        },
      },
      {
        id: 'discountMoney',
        name: t('DiscountMoney'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const discountMoney = xmlProduct
          //   ? $(xmlProduct).find('STCKhau').text()
          //   : row?.discountMoney
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          if (!numberFormat) numberFormat = sysConfig
          let discount = _.isNumber(row?.discount)
            ? parseFloat(row?.discount).toFixed(numberFormat?.ratio)
            : ''
          let discountMoney = _.isNumber(row?.discountMoney)
            ? parseFloat(row?.discountMoney).toFixed(
                numberFormat?.[
                  checkCheck ? 'currencyExchange' : 'foreignCurrency'
                ],
              )
            : ''
          let dataInvoiceMultiProductAndTypes =
            detailInvoices?.dataInvoiceMultiProductAndTypes?.[row?.invoiceId]
          if (
            dataInvoiceMultiProductAndTypes?.length > 0 &&
            (row?.invoiceOfInvoiceProduct?.discountType == 2 ||
              row?.invoiceOfInvoiceProduct?.discountType == 1)
          ) {
            //lấy thông tin hàng hóa ở dataInvoiceMultiProduct
            let invoiceProduct = findObjectInArray(
              dataInvoiceMultiProductAndTypes,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            if (invoiceProduct?.type == 3) {
              discountMoney = 0
            }
          }
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {discount == ''
                ? '0'
                : // Utils.valueFormatted(
                  //     discountMoney,
                  //     row?.numberFormat,
                  //     sysConfig ?? detailInvoices?.systemformatNumber,
                  //     'currencyExchange',
                  //   )
                  formatNumberWithCommas(
                    discountMoney,
                    !['VNĐ', 'VND'].includes(
                      row?.invoiceOfInvoiceProduct?.currency,
                    )
                      ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                          formatNumber)?.[
                          checkCheck ? 'currencyExchange' : 'foreignCurrency'
                        ]
                      : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                          formatNumber)?.[
                          checkCheck ? 'currencyExchange' : 'foreignCurrency'
                        ],
                  )}
            </p>
          )
        },
      },
      {
        id: 'discountMoneyConvert',
        name: t('DiscountMoneyConvert'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // let exchangeRate
          // if (xml) {
          //   const TGiaText = $(xml).find('TGia')?.text()
          //   exchangeRate = TGiaText
          //     ? TGiaText
          //     : row?.invoiceOfInvoiceProduct?.exchangeRate
          // } else {
          //   exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          // }
          // const discountMoneyConvert = xmlProduct
          //   ? Number($(xmlProduct).find('STCKhau').text()) *
          //     Number(exchangeRate)
          //   : row?.discountMoney * row?.invoiceOfInvoiceProduct?.exchangeRate
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          let discountMoney = _.isNumber(row?.discountMoney)
            ? parseFloat(row?.discountMoney).toFixed(
                numberFormat?.[
                  checkCheck ? 'currencyExchange' : 'foreignCurrency'
                ],
              )
            : ''
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          let dataInvoiceMultiProductAndTypes =
            detailInvoices?.dataInvoiceMultiProductAndTypes?.[row?.invoiceId]
          if (
            dataInvoiceMultiProductAndTypes?.length > 0 &&
            (row?.invoiceOfInvoiceProduct?.discountType == 2 ||
              row?.invoiceOfInvoiceProduct?.discountType == 1)
          ) {
            //lấy thông tin hàng hóa ở dataInvoiceMultiProduct
            let invoiceProduct = findObjectInArray(
              dataInvoiceMultiProductAndTypes,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            if (invoiceProduct?.type == 3) {
              discountMoney = 0
            }
          }
          const discountMoneyConvert = Number(discountMoney) * exchangeRate
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                discountMoneyConvert,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'currencyExchange',
              )} */}
              {
                // formatNumberWithCommas(
                //   discountMoneyConvert,
                //   numberFormat
                //     ? numberFormat?.currencyExchange
                //     : sysConfig?.currencyExchange,
                // )
                formatNumberWithCommas(
                  discountMoneyConvert,
                  !['VNĐ', 'VND'].includes(
                    row?.invoiceOfInvoiceProduct?.currency,
                  )
                    ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ]
                    : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ],
                )
              }
            </p>
          )
        },
      },
      {
        id: 'taxRate',
        name: t('Tax') + '(%)',
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const taxRate = xmlProduct
          //   ? $(xmlProduct).find('TSuat').text()
          //   : row?.taxRate
          let taxRate = row?.taxRate ? taxRateInXml(row?.taxRate) : ''
          return (
            <p
              style={{
                textAlign: 'right',
              }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {taxRate}
            </p>
          )
        },
      },
      {
        id: 'taxMoney',
        name: t('VAT'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // let taxMoney
          // if (xml) {
          //   const xmlProduct = $(xml).find('TToan')
          //   taxMoney = $(xmlProduct).find('TgTThue').text()
          // } else {
          //   taxMoney = row?.taxMoney
          // }
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let checkGetTaxMoney = isDifferenceLessThan1(
            row?.taxMoney,
            row?.invoiceOfInvoiceProduct?.taxMoney,
          )
          let taxMoneyTemp = checkGetTaxMoney
            ? row?.invoiceOfInvoiceProduct?.taxMoney
            : row?.taxMoney
          let taxMoney
          let dataInvoiceMultiProduct =
            detailInvoices?.dataInvoiceMultiProduct?.[row?.invoiceId]

          if (dataInvoiceMultiProduct) {
            let dataInvoiceProduct = findObjectInArray(
              dataInvoiceMultiProduct,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            const noMax = findMaxNo(dataInvoiceMultiProduct)
            if (noMax == dataInvoiceProduct?.no) {
              taxMoney = getTaxMoneyInvoiceProductMulti({
                invoiceProducts: dataInvoiceMultiProduct,
                numberFormat,
                checkCheck,
                taxMoneyInvoice: row?.invoiceOfInvoiceProduct?.taxMoney,
                sysConfig,
                invoiceProductIdOther: row?.invoiceProductId,
              })
              if (taxMoney < 0 && row?.taxMoney == 0) {
                taxMoney = 0
              }
            }
          } else {
            if (row?.invoiceOfInvoiceProduct?.taxMoney - row?.taxMoney == 1) {
              taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
            }
          }
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.taxMoney < 0 &&
            !dataInvoiceMultiProduct
          ) {
            taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
          }
          if (!taxMoney) {
            // Kiểm tra trường hợp hóa đơn thay thế
            if (
              row?.invoiceOfInvoiceProduct?.type == 1 &&
              !dataInvoiceMultiProduct
            ) {
              taxMoney = parseFloat(
                row?.invoiceOfInvoiceProduct?.taxMoney ?? 0,
              ).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            } else {
              taxMoney = parseFloat(taxMoneyTemp ?? 0).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            }
          }

          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                taxMoney,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'totalCost',
              )} */}
              {
                // formatNumberWithCommas(
                //   taxMoney,
                //   numberFormat
                //     ? checkCheck
                //       ? numberFormat?.totalCost
                //       : numberFormat?.exchangeTotalCost
                //     : checkCheck
                //       ? sysConfig?.totalCost
                //       : sysConfig?.exchangeTotalCost,
                // )
                formatNumberWithCommas(
                  taxMoney,
                  !['VNĐ', 'VND'].includes(
                    row?.invoiceOfInvoiceProduct?.currency,
                  )
                    ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ]
                    : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ],
                )
              }
            </p>
          )
        },
      },
      {
        id: 'taxMoneyConvert',
        name: t('VATConvert'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // let exchangeRate
          // if (xml) {
          //   const TGiaText = $(xml).find('TGia')?.text()
          //   exchangeRate = TGiaText
          //     ? TGiaText
          //     : row?.invoiceOfInvoiceProduct?.exchangeRate
          // } else {
          //   exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          // }
          // const taxMoneyConvert = xml
          //   ? row?.taxMoney * Number(exchangeRate)
          //   : row?.taxMoney * row?.invoiceOfInvoiceProduct?.exchangeRate
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let checkGetTaxMoney = isDifferenceLessThan1(
            row?.taxMoney,
            row?.invoiceOfInvoiceProduct?.taxMoney,
          )
          let taxMoneyTemp = checkGetTaxMoney
            ? row?.invoiceOfInvoiceProduct?.taxMoney
            : row?.taxMoney

          let taxMoney
          let dataInvoiceMultiProduct =
            detailInvoices?.dataInvoiceMultiProduct?.[row?.invoiceId]
          if (dataInvoiceMultiProduct) {
            let dataInvoiceProduct = findObjectInArray(
              dataInvoiceMultiProduct,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            const noMax = findMaxNo(dataInvoiceMultiProduct)
            if (noMax == dataInvoiceProduct?.no) {
              taxMoney = getTaxMoneyInvoiceProductMulti({
                invoiceProducts: dataInvoiceMultiProduct,
                numberFormat,
                checkCheck,
                taxMoneyInvoice: row?.invoiceOfInvoiceProduct?.taxMoney,
                sysConfig,
                invoiceProductIdOther: row?.invoiceProductId,
              })
              if (taxMoney < 0 && row?.taxMoney == 0) {
                taxMoney = 0
              }
            }
          } else {
            if (row?.invoiceOfInvoiceProduct?.taxMoney - row?.taxMoney == 1) {
              taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
            }
          }
          if (!taxMoney) {
            if (
              row?.invoiceOfInvoiceProduct?.type == 1 &&
              !dataInvoiceMultiProduct
            ) {
              taxMoney = parseFloat(
                row?.invoiceOfInvoiceProduct?.taxMoney ?? 0,
              ).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            } else {
              taxMoney = parseFloat(taxMoneyTemp ?? 0).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            }
          }
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.taxMoney < 0 &&
            !dataInvoiceMultiProduct
          ) {
            taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
          }
          const taxMoneyConvert = taxMoney * Number(exchangeRate)
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="w-100 text-dark-75 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                taxMoneyConvert,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'totalCost',
              )} */}
              {
                // formatNumberWithCommas(
                //   taxMoneyConvert,
                //   numberFormat
                //     ? checkCheck
                //       ? numberFormat?.totalCost
                //       : numberFormat?.exchangeTotalCost
                //     : checkCheck
                //       ? sysConfig?.totalCost
                //       : sysConfig?.exchangeTotalCost,
                // )
                formatNumberWithCommas(
                  taxMoneyConvert,
                  !['VNĐ', 'VND'].includes(
                    row?.invoiceOfInvoiceProduct?.currency,
                  )
                    ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ]
                    : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ],
                )
              }
            </p>
          )
        },
      },
      {
        id: 'totalPayment',
        name: t('TotalPayment'),
        center: true,
        minWidth: '150px',
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // const totalPayment = xmlProduct
          //   ? row?.taxMoney + Number($(xmlProduct).find('ThTien').text())
          //   : row?.taxMoney + row?.totalUnitPrice
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          // let numberFormat = sysConfig
          if (!numberFormat) numberFormat = sysConfig
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let checkGetTaxMoney = isDifferenceLessThan1(
            row?.taxMoney,
            row?.invoiceOfInvoiceProduct?.taxMoney,
          )
          let taxMoneyTemp = checkGetTaxMoney
            ? row?.invoiceOfInvoiceProduct?.taxMoney
            : row?.taxMoney
          let taxMoney
          let dataInvoiceMultiProduct =
            detailInvoices?.dataInvoiceMultiProduct?.[row?.invoiceId]
          if (dataInvoiceMultiProduct) {
            let dataInvoiceProduct = findObjectInArray(
              dataInvoiceMultiProduct,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            const noMax = findMaxNo(dataInvoiceMultiProduct)
            if (noMax == dataInvoiceProduct?.no) {
              taxMoney = getTaxMoneyInvoiceProductMulti({
                invoiceProducts: dataInvoiceMultiProduct,
                numberFormat,
                checkCheck,
                taxMoneyInvoice: row?.invoiceOfInvoiceProduct?.taxMoney,
                sysConfig,
                invoiceProductIdOther: row?.invoiceProductId,
              })
              if (taxMoney < 0 && row?.taxMoney == 0) {
                taxMoney = 0
              }
            }
          } else {
            if (row?.invoiceOfInvoiceProduct?.taxMoney - row?.taxMoney == 1) {
              taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
            }
          }
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.taxMoney < 0 &&
            !dataInvoiceMultiProduct
          ) {
            taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
          }
          if (!taxMoney) {
            if (
              row?.invoiceOfInvoiceProduct?.type == 1 &&
              !dataInvoiceMultiProduct
            ) {
              taxMoney = parseFloat(
                row?.invoiceOfInvoiceProduct?.taxMoney ?? 0,
              ).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            } else {
              taxMoney = parseFloat(taxMoneyTemp ?? 0).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            }
          }

          const taxMoneyConvert = taxMoney * Number(exchangeRate)
          let totalUnitPrice = parseFloat(row?.totalUnitPrice ?? 0).toFixed(
            numberFormat?.totalCost,
          )
          let totalPayment = Number(taxMoneyConvert) + Number(totalUnitPrice)

          let discountMoney = _.isNumber(row?.discountMoney)
            ? parseFloat(row?.discountMoney).toFixed(
                numberFormat?.[
                  checkCheck ? 'currencyExchange' : 'foreignCurrency'
                ],
              )
            : ''
          // Kiểm tra thuế suất
          if (
            row?.invoiceOfInvoiceProduct?.discountType == 1 ||
            row?.invoiceOfInvoiceProduct?.discountType == 2
          ) {
            // totalPayment = row?.totalUnitPriceAfterTax
            totalPayment = totalPayment - (discountMoney ?? 0)
          }
          //Kiểm tra hóa đơn điều chỉnh và số lượng <0
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.type == 2 &&
            row?.quantity <= 0
          ) {
            if (row?.invoiceOfInvoiceProduct?.taxMoney < 0) {
              totalPayment = Number(taxMoneyConvert) + Number(totalUnitPrice)
            } else {
              if (totalPayment == null || totalPayment === '') {
                totalPayment = 0
              }
            }
          }

          // Kiểm tra nếu là hóa đơn nhiều hàng hóa và thuế suất là tổng giá trị hóa đơn
          let dataInvoiceMultiProductAndTypes =
            detailInvoices?.dataInvoiceMultiProductAndTypes?.[row?.invoiceId]
          if (
            dataInvoiceMultiProductAndTypes?.length > 0 &&
            (row?.invoiceOfInvoiceProduct?.discountType == 2 ||
              row?.invoiceOfInvoiceProduct?.discountType == 1)
          ) {
            //lấy thông tin hàng hóa ở dataInvoiceMultiProduct
            let invoiceProduct = findObjectInArray(
              dataInvoiceMultiProductAndTypes,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            if (invoiceProduct?.type == 3) {
              totalPayment = 0
            }
          }

          //Kiểm tra hóa đơn điều chỉnh và điều chỉnh thuế suất
          // if (
          //   row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
          //   row?.invoiceOfInvoiceProduct?.type == 2 &&
          //   row?.invoiceOfInvoiceProduct?.totalAfterTax < 0 &&
          //   !dataInvoiceMultiProductAndTypes
          // ) {
          //   totalPayment = row?.invoiceOfInvoiceProduct?.totalAfterTax
          // }

          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                totalPayment,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'totalCost',
              )} */}

              {
                // formatNumberWithCommas(
                //   totalPayment,
                //   numberFormat ? numberFormat?.totalCost : sysConfig?.totalCost,
                // )
                formatNumberWithCommas(
                  totalPayment,
                  !['VNĐ', 'VND'].includes(
                    row?.invoiceOfInvoiceProduct?.currency,
                  )
                    ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ]
                    : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ],
                )
              }
            </p>
          )
        },
      },
      {
        id: 'totalPaymentConvert',
        name: t('TotalPaymentConvert'),
        center: true,
        cell: (row) => {
          // const xml = reportHelper.readXmlString(
          //   row?.invoiceOfInvoiceProduct?.xmlString,
          // )
          // const xmlProduct = xml
          //   ? $(xml)
          //       .find('DSHHDVu > HHDVu')
          //       .eq(+row?.no - 1)
          //   : null
          // let exchangeRate
          // if (xml) {
          //   const TGiaText = $(xml).find('TGia')?.text()
          //   exchangeRate = TGiaText
          //     ? TGiaText
          //     : row?.invoiceOfInvoiceProduct?.exchangeRate
          // } else {
          //   exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          // }
          // const totalPaymentConvert = xmlProduct
          //   ? (row?.taxMoney + Number($(xmlProduct).find('ThTien').text())) *
          //     Number(exchangeRate)
          //   : (row?.taxMoney + row?.totalUnitPrice) *
          //     row?.invoiceOfInvoiceProduct?.exchangeRate
          let exchangeRate = row?.invoiceOfInvoiceProduct?.exchangeRate
          let numberFormat = parseJSONSafely(
            row?.invoiceOfInvoiceProduct?.numberFormat,
          )
          if (!numberFormat) numberFormat = sysConfig
          let checkCheck = ['VND', 'VNĐ'].includes(
            row?.invoiceOfInvoiceProduct?.currency,
          )
          let checkGetTaxMoney = isDifferenceLessThan1(
            row?.taxMoney,
            row?.invoiceOfInvoiceProduct?.taxMoney,
          )
          let taxMoneyTemp = checkGetTaxMoney
            ? row?.invoiceOfInvoiceProduct?.taxMoney
            : row?.taxMoney
          let taxMoney
          let dataInvoiceMultiProduct =
            detailInvoices?.dataInvoiceMultiProduct?.[row?.invoiceId]
          if (dataInvoiceMultiProduct) {
            let dataInvoiceProduct = findObjectInArray(
              dataInvoiceMultiProduct,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            const noMax = findMaxNo(dataInvoiceMultiProduct)
            if (noMax == dataInvoiceProduct?.no) {
              taxMoney = getTaxMoneyInvoiceProductMulti({
                invoiceProducts: dataInvoiceMultiProduct,
                numberFormat,
                checkCheck,
                taxMoneyInvoice: row?.invoiceOfInvoiceProduct?.taxMoney,
                sysConfig,
                invoiceProductIdOther: row?.invoiceProductId,
              })
              if (taxMoney < 0 && row?.taxMoney == 0) {
                taxMoney = 0
              }
            }
          } else {
            if (row?.invoiceOfInvoiceProduct?.taxMoney - row?.taxMoney == 1) {
              taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
            }
          }
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.taxMoney < 0 &&
            !dataInvoiceMultiProduct
          ) {
            taxMoney = row?.invoiceOfInvoiceProduct?.taxMoney
          }
          if (!taxMoney) {
            if (
              row?.invoiceOfInvoiceProduct?.type == 1 &&
              !dataInvoiceMultiProduct
            ) {
              taxMoney = parseFloat(
                row?.invoiceOfInvoiceProduct?.taxMoney ?? 0,
              ).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            } else {
              taxMoney = parseFloat(taxMoneyTemp ?? 0).toFixed(
                numberFormat
                  ? checkCheck
                    ? numberFormat?.currencyExchange
                    : numberFormat?.foreignCurrency
                  : checkCheck
                    ? sysConfig?.currencyExchange
                    : sysConfig?.foreignCurrency,
              )
            }
          }

          const taxMoneyConvert = taxMoney * Number(exchangeRate)
          let totalUnitPrice = parseFloat(row?.totalUnitPrice ?? 0).toFixed(
            numberFormat
              ? checkCheck
                ? numberFormat?.currencyExchange
                : numberFormat?.foreignCurrency
              : checkCheck
                ? sysConfig?.currencyExchange
                : sysConfig?.foreignCurrency,
          )
          const totalPayment = Number(taxMoneyConvert) + Number(totalUnitPrice)

          let discountMoney = _.isNumber(row?.discountMoney)
            ? parseFloat(row?.discountMoney).toFixed(
                numberFormat?.[
                  checkCheck ? 'currencyExchange' : 'foreignCurrency'
                ],
              )
            : ''

          let totalPaymentConvert = totalPayment * exchangeRate
          // Kiểm tra thuế suất
          if (
            row?.invoiceOfInvoiceProduct?.discountType == 1 ||
            row?.invoiceOfInvoiceProduct?.discountType == 2
          ) {
            totalPaymentConvert =
              (totalPayment - discountMoney ?? 0) * exchangeRate
          }
          if (
            row?.invoiceOfInvoiceProduct?.originalInvoiceId &&
            row?.invoiceOfInvoiceProduct?.type == 2 &&
            row?.quantity <= 0
          ) {
            if (row?.invoiceOfInvoiceProduct?.taxMoney < 0) {
              totalPaymentConvert =
                (Number(taxMoneyConvert) +
                  Number(totalUnitPrice) -
                  discountMoney ?? 0) * exchangeRate
            } else {
              if (totalPaymentConvert == null || totalPaymentConvert === '') {
                totalPaymentConvert = 0
              }
            }
          }
          // Kiểm tra nếu là hóa đơn nhiều hàng hóa và thuế suất là tổng giá trị hóa đơn
          let dataInvoiceMultiProductAndTypes =
            detailInvoices?.dataInvoiceMultiProductAndTypes?.[row?.invoiceId]
          if (
            dataInvoiceMultiProductAndTypes?.length > 0 &&
            (row?.invoiceOfInvoiceProduct?.discountType == 2 ||
              row?.invoiceOfInvoiceProduct?.discountType == 1)
          ) {
            //lấy thông tin hàng hóa ở dataInvoiceMultiProduct
            let invoiceProduct = findObjectInArray(
              dataInvoiceMultiProductAndTypes,
              'invoiceProductId',
              row?.invoiceProductId,
            )
            if (invoiceProduct?.type == 3) {
              totalPaymentConvert = 0
            }
          }
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {/* {Utils.valueFormatted(
                totalPaymentConvert,
                row?.numberFormat,
                sysConfig ?? detailInvoices?.systemformatNumber,
                'totalCost',
              )} */}
              {
                // formatNumberWithCommas(
                //   totalPaymentConvert,
                //   numberFormat
                //     ? checkCheck
                //       ? numberFormat?.totalCost
                //       : numberFormat?.exchangeTotalCost
                //     : checkCheck
                //       ? sysConfig?.totalCost
                //       : sysConfig?.exchangeTotalCost,
                // )
                formatNumberWithCommas(
                  totalPaymentConvert,
                  !['VNĐ', 'VND'].includes(
                    row?.invoiceOfInvoiceProduct?.currency,
                  )
                    ? (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ]
                    : (row?.invoiceOfInvoiceProduct?.numberFormat ??
                        formatNumber)?.[
                        checkCheck ? 'currencyExchange' : 'foreignCurrency'
                      ],
                )
              }
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.issueStatus',
        name: t('IssueStatus'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          const issueStatus = row?.invoiceOfInvoiceProduct?.issueStatus
          return (
            <p
              data-tag="allowRowEvents"
              className={`m-0 badge badge-light-${reportHelper.getInvoiceStatusColor(
                issueStatus,
              )}`}
              style={{ whiteSpace: 'nowrap' }}
            >
              {reportHelper.getInvoiceStatus(issueStatus)}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.sendTaxStatus',
        name: t('Trạng thái gửi CQT'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          const sendTaxStatus = row?.invoiceOfInvoiceProduct?.sendTaxStatus
          const { color, text } =
            InvoiceHelper.renderSendTaxStatus(sendTaxStatus)
          return <div className={`badge badge-light-${color}`}>{text}</div>
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.plateNumber',
        name: t('Biển kiểm soát'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {
                row?.plateNumber
                // ? row?.plateNumber
                // : detailInvoices?.dataInvoiceLicensePlate?.[
                //     row?.invoiceOfInvoiceProduct?.invoiceId
                //   ]
              }
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerPersonalIdentificationNumber',
        name: t('Căn cước công dân'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {
                row?.invoiceOfInvoiceProduct
                  ?.customerPersonalIdentificationNumber
              }
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerPassportNumber',
        name: t('Số hộ chiếu'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {row?.invoiceOfInvoiceProduct?.customerPassportNumber}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerPhone',
        name: t('Số điện thoại'),
        minWidth: '130px',
        center: true,
        cell: (row) => {
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {row?.invoiceOfInvoiceProduct?.customerPhone}
            </p>
          )
        },
      },
      {
        id: 'invoiceOfInvoiceProduct.customerPhone',
        name: t('Mã tra cứu'),
        minWidth: '135px',
        center: true,
        cell: (row) => {
          return (
            <p
              style={{ textAlign: 'right' }}
              data-tag="allowRowEvents"
              className="text-dark-75 w-100 font-weight-normal m-0 text-maxline-3"
            >
              {row?.invoiceOfInvoiceProduct?.lookupCode}
            </p>
          )
        },
      },
    ],
    [
      sysConfig,
      t,
      detailInvoices?.systemformatNumber,
      detailInvoices?.dataInvoiceMultiProduct,
      formatNumber,
      sysConfig,
      // detailInvoices?.dataInvoiceLicensePlate,
    ],
  )

  const dynamicColumns = useAppDnD(fullColumns)

  // MARK --- Functions ---

  const { mutate: handleExportExcel } = useExportMutation()
  // MARK --- Hooks ---
  useEffect(() => {
    setFilters({
      q: debouncedSearch,
      page: 1,
    })
  }, [debouncedSearch, setFilters])

  const onExport = () => {
    if (refetch) {
      refetch()
    }
  }

  const onchangeDate = (name, value, dateRange) => {
    if (name) {
      setDateSerial(getYearsFromDates({ ...filters, [name]: value }))
    } else {
      setDateSerial(
        getYearsFromDates({
          ...filters,
          startDate: dateRange[0],
          endDate: dateRange[1],
        }),
      )
    }
  }

  useEffect(() => {
    setDateSerial(getYearsFromDates(filters))
  }, [])

  const getFileCache = async (data) => {
    const res = await reportApi.exportReportFile(
      {
        ...JSON.parse(data.stringRequest),
      },
      {
        cache: 1,
        typeReport: data.typeReport,
        fileCacheHas: data.fileCacheHas,
        nameFile: data?.nameFile,
      },
      'blob',
    )
    const blob = new Blob([res], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    saveAs(blob, data?.nameFile ?? 'baocaochitiet.xlsx')
  }

  return (
    <ContentContainer>
      <button
        onClick={onExport}
        style={{ display: 'none' }}
        id="refetchBaoCaoChiTiet"
      >
        refetch
      </button>
      <ContentContainer.Header
        titleContent={t('DetailedListOfUsedInvoices')}
        description={`${t('Tổng')}: ${Utils.formatNumber(
          detailInvoices?.total,
        )} ${t('Hóa đơn')}`}
        toolBar={
          <Space>
            {detailInvoices?.fileReport && (
              <CustomAntButton
                title={'File đã được xuất từ trước'}
                text={detailInvoices?.fileReport?.nameFile}
                iconCn={Utils.cn(
                  'fa-solid mr-2 p-0',
                  'fa-solid fa-file-excel',
                  // isPending ? 'fa-spinner-third fa-spin' : 'fa-down-to-line',
                )}
                antProps={{
                  disabled: props?.inforExportReportFileDetail?.disable,
                  className: 'btn btn-success',
                  onClick: () => {
                    getFileCache(detailInvoices?.fileReport)
                  },
                }}
              />
            )}
            <CustomAntButton
              text="Xuất excel"
              iconCn={Utils.cn(
                'fa-solid mr-2 p-0',
                props?.inforExportReportFileDetail?.disable
                  ? 'fa-spinner-third fa-spin'
                  : 'fa-down-to-line',
                // isPending ? 'fa-spinner-third fa-spin' : 'fa-down-to-line',
              )}
              antProps={{
                disabled: props?.inforExportReportFileDetail?.disable,
                className: 'btn btn-success',
                onClick: () => {
                  let accessToken = localStorage.getItem(
                    PreferenceKeys.accessToken,
                  )
                  wsHelperInstance.onExecutingReportFile(
                    accessToken,
                    props?.setInforExportReportFileDetail,
                    true,
                  )
                  handleExportExcel(_.omit(filters, ['page', 'limit']))
                  // setInforSettingTool({ show: true })
                },
              }}
            />
            <AppDnD
              defaultColumns={fullColumns}
              localStorageName={PreferenceKeys.savedColumnsDetailInvoice}
            />
          </Space>
        }
      >
        <Space wrap>
          <CustomAntInput
            type="search"
            borderRadius="base"
            inputProps={{
              value: search,
              onChange: (e) => setSearch(e.target.value),
            }}
          />
          <FilterPopover
            menuPosition="bottomRight"
            defaultValues={[
              {
                alias: 'Kí hiệu',
                label: 'Ký hiệu',
                formName: 'serials',
                options: serials,
                value: null,
                colSpan: 24,
                multiselect: true,
              },
              {
                label: ['Hoá đơn từ số', 'Đến số'],
                formName: ['fromNumberInvoice', 'toNumberInvoice'],
                alias: 'Số hoá đơn: Từ',
                separator: 'Đến',
                value: [null, null],
                restrict: {
                  type: 'number',
                  min: 1,
                  max: 99999999,
                },
              },
              {
                label: 'Trạng thái phát hành',
                alias: 'Trạng thái phát hành',
                formName: 'statusReleaseInvoiceReports',
                options: SelectOptions.statusReleaseInvoiceReplace,
                value: SelectOptions.statusReleaseInvoiceReplace[0].value,
              },
              {
                label: 'Tên hàng hóa',
                alias: 'Hàng hóa',
                formName: 'goodsName',
                options: goodsOptions,
                value: null,
              },
              {
                alias: 'Loại HĐ',
                label: 'Loại hóa đơn',
                formName: 'addTypeInvoiceRemove',
                value: null,
                options: SelectOptions.invoiceTypeAddType,
              },
              {
                alias: 'Trạng thái hóa đơn',
                label: 'Trạng thái hóa đơn',
                formName: 'types',
                value: null,
                options: SelectOptions.invoiceType,
              },
            ]}
            onApply={setFilters}
            savedKey="gFiltersDetailInvoices"
            onchangeDate={onchangeDate}
          />
        </Space>
      </ContentContainer.Header>
      <ContentContainer.Body>
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={detailInvoices?.rows}
          customTableStyle={customDataTableStyle}
          isLoading={isGettingDetailInvoice}
          pagination={{
            currentPage: filters?.page,
            rowsPerPage: filters?.limit,
            total: detailInvoices?.total,
            onChangePage: (newPage) => {
              let iNewPage = parseInt(newPage)
              setFilters({
                page: iNewPage,
              })
            },
            onChangeRowsPerPage: (limit) => {
              const iNewPerPage = parseInt(limit)
              setFilters({
                limit: iNewPerPage,
                page: 1,
              })
            },
          }}
        />
      </ContentContainer.Body>

      <ModalWrapperTool
        title={t('Cảnh báo')}
        open={inforSettingTool.show}
        onCancel={() => setInforSettingTool({ show: false })}
        width={650}
        footer={
          <DivFooter>
            <DivRowFooter className="row">
              <DivColFooter className="col-6"></DivColFooter>
              <DivColFooter className="col-6" justifyContent={'right'}>
                <ButtonSave
                  style={{ backgroundColor: '#49b454' }}
                  type="primary"
                  onClick={() => {
                    // handleDownloadApp(1)
                    setInforSettingTool({ show: false })
                  }}
                >
                  {t('tool.yes')}
                </ButtonSave>
              </DivColFooter>
            </DivRowFooter>
          </DivFooter>
        }
      >
        <span style={{ color: '#5e6166' }}>
          Vui lòng gọi điện thoại tới tổng đài{' '}
          <a href="tel: 1900.0099" style={{ color: 'red' }}>
            1900.0099
          </a>{' '}
        </span>
      </ModalWrapperTool>
    </ContentContainer>
  )
}

export default DetailInvoiceReportScreen
